import { Card, CardContent } from "../../../shared/components/ui/Card";
import { DatabaseTable } from "../../../shared/components/ui/DatabaseTable";
import { useDashboard } from "../context/useDashboard";
import type { GridColDef } from "@mui/x-data-grid";
import { Chip } from "@mui/material";

export const AccessLogTable = () => {
    const { accessLogs, isLoadingAccessLogs } = useDashboard();
    
    const columns: GridColDef[] = [
        { field: 'userName', headerName: 'Usuário', flex: 1 },
        { field: 'accessType', headerName: 'Tipo de Acesso', flex: 1 },
        { 
            field: 'createdAt', 
            headerName: 'Data de Acesso', 
            flex: 1,
            valueFormatter: (params) => {
                return new Date(params.value).toLocaleString('pt-BR');
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    color={params.value === 'ERROR' ? 'error' : 'success'}
                    size="small"
                    variant="outlined"
                />
            )
        },
        { field: 'tenantName', headerName: 'Empresa', flex: 1 },
        { 
            field: 'antiSpoofingResult',
            headerName: 'Anti-Spoofing',
            flex: 2,
            minWidth: 200,
            valueGetter: (params) => {
                const result = params.row.antiSpoofingResult;
                return result ? `${result.status} (${result.liveness})` : '-';
            }
        },
        {
            field: 'faceVerificationResult',
            headerName: 'Verificação Facial',
            flex: 2,
            minWidth: 200,
            valueGetter: (params) => {
                const result = params.row.faceVerificationResult;
                return result ? `${result.success ? 'Sucesso' : 'Falha'} (${result.faceId})` : '-';
            }
        },
        { 
            field: 'errorMessage', 
            headerName: 'Mensagem de Erro', 
            flex: 2,
            minWidth: 200,
            valueGetter: (params) => params.row.errorMessage || '-'
        }
    ];

    return (
        <DatabaseTable 
            columns={columns} 
            rows={accessLogs || []} 
            hideDelete 
            hideEdit 
            hideView 
            loading={isLoadingAccessLogs} 
            title="Acessos"
        />
    );
}; 